import React, { Component } from 'react';
import { DatePicker, Select, Button, message, Spin } from 'antd';
import moment from "moment";
import optionData from "./data";
import chart from "./chart";
import "./index.scss";

const { RangePicker } = DatePicker;
const { Option } = Select;

class App extends Component {
    state = {
        startTime: moment().format('YYYY-MM') + "-01",
        endTime: moment().format('YYYY-MM-DD'),
        data: {
            type: "daily_month",
            name: "Total Rooms <br/>总房数",
            key: "actual,last"
        },
        loading: false
    }

    componentDidMount() {
        this.onSubmit();
    }

    onSubmit = async () => {
        this.setState({ loading: true });
        try {
            const { data, startTime, endTime } = this.state;

            if (moment(startTime).format('YYYY') != moment(endTime).format('YYYY')) {
                message.error('请选择相同年份！');
                this.setState({ loading: false });
                return
            }
            const key = data.key.split(",");
            let dataFrom = new FormData();
            dataFrom.append('data', JSON.stringify({
                ...data,
                year: key[0],
                last: key[1],
                type: data.type.includes("total") ? 'daily_total' : data.type,
                year: moment(startTime).format('YYYY'),
                startMonth: moment(startTime).format('M'),
                startDay: moment(startTime).format('D'),
                endDay: moment(endTime).format('D'),
                endMonth: moment(endTime).format('M'),
            }));
            let headres = {
                method: 'post',
                credentials: 'include',
                headers: {},
                body: dataFrom
            }
            let json = await fetch('/dayChart  ', headres);
            let res = await json.json();

            chart(res.data, data);
            this.setState({ loading: false });
        } catch (error) {
            console.log(error);
            message.error('数据处理失败！');
            this.setState({ loading: false });
        }
    }

    render() {
        const { startTime, endTime, data, loading } = this.state;
        const nameList = optionData.find(x => x.value === data.type).children || [];
        const keyList = nameList.find(x => x.value === data.name).children || [];
        return (
            <Spin spinning={loading}>
                <div className="dailyChart">
                    <div className="title">1.2 单酒店月度数据去年同比分析</div>
                    <div className="month-select">
                        {/* <MonthPicker
                            placeholder="请选择年月"
                            monthCellContentRender={(date, local) => {
                                return moment(date).format('M月')
                            }}
                            allowClear={false}
                            defaultValue={moment(startTime, 'YYYY-MM')}
                            format="YYYY-MM"
                            disabledDate={currentDate => moment(endTime).isBefore(currentDate)}
                            onChange={(date, str) => {
                                this.setState({ startTime: str });
                            }}
                        />
                        <span className="line">-</span>
                        <MonthPicker
                            placeholder="请选择年月"
                            monthCellContentRender={(date, local) => {
                                return moment(date).format('M月')
                            }}
                            allowClear={false}
                            defaultValue={moment(endTime, 'YYYY-MM')}
                            format="YYYY-MM"
                            disabledDate={currentDate => {
                                return moment(currentDate).isBefore(startTime)
                            }}
                            onChange={(date, str) => {
                                this.setState({ endTime: str });
                            }}
                        /> */}
                        <RangePicker
                            value={[moment(startTime, 'YYYY-MM-DD'), moment(endTime, 'YYYY-MM-DD')]}
                            onChange={(date, str) => {
                                this.setState({ startTime: str[0], endTime: str[1] });
                            }}
                        />
                    </div>

                    <div style={{ marginTop: 20 }}>
                        <Select
                            className="select-style"
                            value={data.type}
                            onChange={v => {
                                let d = { ...data, type: v };
                                const name = optionData.find(x => x.value === v).children;
                                d.name = name[0].value;
                                const key = name.find(x => x.value === d.name).children;
                                d.key = key[0].value;
                                this.setState({ data: d });
                            }}
                        >
                            {optionData.map(v => {
                                return <Option key={v.value} value={v.value}>
                                    {v.name.replace("<br/>", " ")}
                                </Option>
                            })}
                        </Select>
                        <Select
                            className="select-style"
                            value={data.name}
                            onChange={v => {
                                let d = { ...data, name: v };
                                d.key = nameList.find(x => x.value === v).children[0].value;
                                this.setState({ data: d });
                            }}
                        >
                            {nameList.map(v => {
                                return <Option key={v.value} value={v.value}>
                                    {v.name.replace("<br/>", " ")}
                                </Option>
                            })}
                        </Select>
                        <Select
                            className="select-style"
                            value={data.key}
                            onChange={v => {
                                let d = { ...data, key: v };
                                this.setState({ data: d });
                            }}
                        >
                            {keyList.map(v => {
                                return <Option key={v.value} value={v.value}>
                                    {v.name.replace("<br/>", " ")}
                                </Option>
                            })}
                        </Select>

                        <Button
                            type="primary"
                            onClick={this.onSubmit}
                        >
                            确定
                    </Button>
                    </div>

                    <div id="chart-element" style={{ height: 400, marginTop: 20 }}></div>
                </div >
            </Spin>
        );
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/daily/1.2/index.js